






































import { Component, Emit, Mixins, Prop } from 'vue-property-decorator'
import fab from 'vue-fab'
import BaseComponent from '@/tcw/components/BaseComponent'
import { KintaiActionMenu } from '../types'
import { MobileAction } from '@/tcw/domain/types'

@Component({
  components: { fab }
})
export default class KintaiAction extends Mixins(BaseComponent) {
  @Prop({ default: () => [] })
  private actions!: KintaiActionMenu[]

  @Emit()
  private action(_command: string) {
    //
  }

  /**
   * モバイル用のFAB設定
   */
  get mobileActions(): MobileAction[] {
    return this.actions.map(a => {
      return {
        name: a.command,
        tooltip: a.label,
        icon: a.icon,
        color: '#0000cd'
      }
    })
  }
}
